import type { Order, OrderV2 } from "@cede/types";

/**
 * Converts an OrderV2 (Decimal fields) to an Order (number fields).
 * Used at the frontend boundary where downstream code (orderToTransactionMapper,
 * onTradeSubmitted, etc.) expects Order with number fields.
 */
export function orderV2ToOrder(orderV2: OrderV2): Order {
  return {
    ...orderV2,
    triggerPrice: orderV2.triggerPrice?.toNumber(),
    price: orderV2.price.toNumber(),
    amount: orderV2.amount.toNumber(),
    filled: orderV2.filled?.toNumber() ?? 0, // ccxt omitZero(): omitted fill = 0
    fee: {
      ...orderV2.fee,
      amount: orderV2.fee.amount.toNumber(),
      refAmount: orderV2.fee.refAmount != null ? orderV2.fee.refAmount.toNumber() : undefined,
    },
    trades: orderV2.trades?.map((t) => ({
      ...t,
      price: t.price.toNumber(),
      amount: t.amount.toNumber(),
      fee: {
        ...t.fee,
        amount: t.fee.amount.toNumber(),
        refAmount: t.fee.refAmount != null ? t.fee.refAmount.toNumber() : undefined,
      },
    })),
  };
}
